<template>
    <div class="carousel-slider">
        <div class="carousel-slider--slides">
            <div class="carousel-slider--rail" :style="wrapStyles">
                <div class="carousel-slider--item grid--col" v-for="(item, itemIdx) in items"
                        ref="item"
                        :style="itemStyles">
                    <slot name="item" :item="item" :is-active="itemIdx === state.idx" :item-idx="itemIdx">
                        <!-- fallback content -->
                    </slot>
                </div>
            </div>
        </div>

        <slot name="arrow-nav"
                :num-items="items.length"
                :active-idx="state.idx"
                :change-handler="onRequestChange">
            <!-- fallback content -->
        </slot>

        <slot name="bullet-nav"
                :num-items="items.length"
                :active-idx="state.idx"
                :change-handler="onRequestChange">
            <!-- fallback content -->
        </slot>
    </div>
</template>

<script>
    import bemMixin from 'framework/mixins/bem';
    import uiPatternMixin from 'framework/mixins/ui-pattern';


    export default {
        mixins: [
            bemMixin('carousel'),
            uiPatternMixin('idx'),
        ],
        props: {
            items: {
                type: Array,
                required: true,
            },
            idx: {
                type: Number,
                default: 0,
            },
        },
        data() {
            return {
                state: {},
            };
        },
        computed: {
            rootClasses() {
                return [
                    this.bemFacet,
                ];
            },
            wrapStyles() {
                return {
                    width: `${ this.numItems * 100 }%`,
                    transform: `rotateZ(1turn) translateX(${ this.state.idx * -100 / this.numItems }%)`,
                };
            },
            numItems() {
                return this.items.length;
            },
            itemStyles() {
                return {
                    width: `${ 100 / this.numItems }%`,
                };
            },
            itemCount() {
                return `${ this.state.idx + 1 } / ${ this.numItems }`;
            },
        },
    };
</script>



// WEBPACK FOOTER //
// vehi-industriepfad/assets/src/js/app/framework/components/ui/carousel/carousel-slider/index.vue?3b9b1be0